import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import GoogleMap from 'google-map-react';
import classNames from 'classnames';

import { isLatitude, isLongitude } from 'aurora-utils/utils';
import styles from './styles';

const defaultCoords = {
  lat: 59.95,
  lng: 30.33,
};

// eslint-disable-next-line react/prop-types
function Marker({ classes }) {
  // eslint-disable-next-line react/prop-types
  return <LocationOnIcon color='primary' className={classes.marker} />;
}

function ADGMMap(props) {
  const { classes, className, lat, lng, zoom, locale } = props;

  const coords = {
    lat: isLatitude(lat) ? parseFloat(lat) : defaultCoords.lat,
    lng: isLongitude(lng) ? parseFloat(lng) : defaultCoords.lng,
  };

  return (
    <div className={classNames(classes.container, className)}>
      <style>
        {`
        .gm-fullscreen-control > img:not(:first-child) {
          display: none;
        }
      `}
      </style>
      <GoogleMap
        center={coords}
        zoom={zoom}
        bootstrapURLKeys={{
          key: process.env.REACT_APP_GOOGLE_API,
          language: locale,
        }}
      >
        <Marker lat={coords.lat} lng={coords.lng} classes={classes} />
      </GoogleMap>
    </div>
  );
}

ADGMMap.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  lat: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  lng: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  zoom: PropTypes.number,
  locale: PropTypes.string,
};

ADGMMap.defaultProps = {
  className: {},
  zoom: 10,
  locale: 'en',
  lat: 0,
  lng: 0,
};

export default withStyles(styles)(ADGMMap);
